import BACKSTAGE_CREATEFILE from "./backstage/CreateFile.json"
import BACKSTAGE_UPDATEBATCH from "./backstage/UpdateBatch.json"
import BACKSTAGE_CLOSEPROJECT from "./backstage/CloseProject.json"
import BACKSTAGE_CREATEOPTION from "./backstage/CreateOption.json"
import BACKSTAGE_UPDATEPROJECT from "./backstage/UpdateProject.json"
import BACKSTAGE_CREATEPROJECT from "./backstage/CreateProject.json"
import BACKSTAGE_CREATEPROPERTY from "./backstage/CreateProperty.json"
import BACKSTAGE_ARCHIVEPROJECT from "./backstage/ArchiveProject.json"
import BACKSTAGE_PUBLISHPROJECT from "./backstage/PublishProject.json"
import BACKSTAGE_ENABLEMYUSER2FA from "./backstage/EnableMyUser2FA.json"
import BACKSTAGE_UNPUBLISHPROJECT from "./backstage/UnpublishProject.json"
import BACKSTAGE_CREATEBATCHFILES from "./backstage/CreateBatchFiles.json"
import BACKSTAGE_UPDATEPARTNERPROJECT from "./backstage/UpdatePartnerProject.json"
import BACKSTAGE_MAPINVESTMENTDOCUMENTS from "./backstage/MapInvestmentDocuments.json"
import BACKSTAGE_CREATEBATCHINVESTORFILES from "./backstage/CreateBatchInvestorFiles.json"
import NOTIFICATIONS_RESETTEMPLATE from "./notifications/ResetTemplate.json"
import NOTIFICATIONS_UPDATETEMPLATE from "./notifications/UpdateTemplate.json"
import NOTIFICATIONS_TOGGLETEMPLATE from "./notifications/ToggleTemplate.json"
import NOTIFICATIONS_SENDNOTIFICATION from "./notifications/SendNotification.json"
import NOTIFICATIONS_SENDCONTACTUSGUESTNOTIFICATION from "./notifications/SendContactUsGuestNotification.json"
import NOTIFICATIONS_SENDCONTACTUSINVESTORNOTIFICATION from "./notifications/SendContactUsInvestorNotification.json"
import NOTIFICATIONS_SENDINVESTMENTPENDINGREFUNDNOTIFICATION from "./notifications/SendInvestmentPendingRefundNotification.json"
import NOTIFICATIONS_SENDDISTRIBUTIONPENDINGAPPROVALNOTIFICATION from "./notifications/SendDistributionPendingApprovalNotification.json"
import CAMPAIGNS_CLONECAMPAIGN from "./campaigns/CloneCampaign.json"
import CAMPAIGNS_CREATECAMPAIGN from "./campaigns/CreateCampaign.json"
import CAMPAIGNS_UPDATECAMPAIGN from "./campaigns/UpdateCampaign.json"
import CAMPAIGNS_PUBLISHCAMPAIGN from "./campaigns/PublishCampaign.json"
import CAMPAIGNS_UNPUBLISHCAMPAIGN from "./campaigns/UnpublishCampaign.json"
import CAMPAIGNS_UPDATECAMPAIGNTAGS from "./campaigns/UpdateCampaignTags.json"
import INVESTMENTS_CREATECOMMITMENT from "./investments/CreateCommitment.json"
import INVESTMENTS_POSTPONECOMMITMENT from "./investments/PostponeCommitment.json"
import INVESTMENTS_CREATEACCOUNT from "./investments/CreateAccount.json"
import INVESTMENTS_UPDATEACCOUNT from "./investments/UpdateAccount.json"
import INVESTMENTS_IMPORTACCOUNTS from "./investments/ImportAccounts.json"
import INVESTMENTS_IMPORTINVESTMENTS from "./investments/ImportInvestments.json"
import INVESTMENTS_UPDATEACCOUNTNOTE from "./investments/UpdateAccountNote.json"
import INVESTMENTS_UPDATEMYINVESTMENT from "./investments/UpdateMyInvestment.json"
import INVESTMENTS_RESETACCOUNTIDENTITY from "./investments/ResetAccountIdentity.json"
import INVESTMENTS_CONNECTACCOUNTIDENTITY from "./investments/ConnectAccountIdentity.json"
import INVESTMENTS_UPDATEINVESTMENTNOTE from "./investments/UpdateInvestmentNote.json"
import INVESTMENTS_RESETINVESTMENTSUBSCRIPTION from "./investments/ResetInvestmentSubscription.json"
import INVESTMENTS_UPDATEINVESTMENTSOURCES from "./investments/UpdateInvestmentSources.json"
import INVESTMENTS_MIGRATECOMMITMENT from "./investments/MigrateCommitment.json"
import INVESTMENTS_BACKUPINVESTMENT from "./investments/BackupInvestment.json"
import INVESTMENTS_ACCEPTINVESTMENT from "./investments/AcceptInvestment.json"
import INVESTMENTS_REJECTINVESTMENT from "./investments/RejectInvestment.json"
import INVESTMENTS_UPDATEMYINVESTMENTSOURCES from "./investments/UpdateMyInvestmentSources.json"
import INVESTMENTS_CREATEACCOUNTINVESTMENT from "./investments/CreateAccountInvestment.json"
import INVESTMENTS_UPDATEMYINVESTMENTFUNDINGSTATUS from "./investments/UpdateMyInvestmentFundingStatus.json"
import TRANSACTIONS_CONNECTSOURCE from "./transactions/ConnectSource.json"
import TRANSACTIONS_FUNDINVESTMENT from "./transactions/FundInvestment.json"
import TRANSACTIONS_REJECTTRANSACTION from "./transactions/RejectTransaction.json"
import TRANSACTIONS_CREATEBANKACCOUNT from "./transactions/CreateBankAccount.json"
import TRANSACTIONS_APPROVETRANSACTION from "./transactions/ApproveTransaction.json"
import TRANSACTIONS_CONNECTCUSTOMSOURCE from "./transactions/ConnectCustomSource.json"
import TRANSACTIONS_VERIFYMYCUSTOMSOURCE from "./transactions/VerifyMyCustomSource.json"
import TRANSACTIONS_RETRYERRORTRANSACTION from "./transactions/RetryErrorTransaction.json"
import TRANSACTIONS_RETRYFAILEDTRANSACTION from "./transactions/RetryFailedTransaction.json"
import TRANSACTIONS_TRANSFERCONTROLLERCUSTOMERS from "./transactions/TransferControllerCustomers.json"
import TRANSACTIONS_UPDATEREJECTEDTRANSACTIONAMOUNT from "./transactions/UpdateRejectedTransactionAmount.json"
import TRANSACTIONS_CREATEUNVERIFIEDPERSONALCUSTOMER from "./transactions/CreateUnverifiedPersonalCustomer.json"
import TRANSACTIONS_CREATEUNVERIFIEDBUSINESSCUSTOMER from "./transactions/CreateUnverifiedBusinessCustomer.json"
import TRANSACTIONS_UPDATEMYSOURCEVERIFICATIONSTATUS from "./transactions/UpdateMySourceVerificationStatus.json"
import TRANSACTIONS_CREATERECEIVEONLYBUSINESSCUSTOMER from "./transactions/CreateReceiveOnlyBusinessCustomer.json"
import TRANSACTIONS_UPDATEMYCUSTOMERVERIFICATIONSTATUS from "./transactions/UpdateMyCustomerVerificationStatus.json"
import TRANSACTIONS_UPGRADEMYUNVERIFIEDPERSONALCUSTOMER from "./transactions/UpgradeMyUnverifiedPersonalCustomer.json"
import TRANSACTIONS_UPGRADEMYUNVERIFIEDBUSINESSCUSTOMER from "./transactions/UpgradeMyUnverifiedBusinessCustomer.json"
import TRANSACTIONS_CREATEIMPERSONATEDUNVERIFIEDPERSONALCUSTOMER from "./transactions/CreateImpersonatedUnverifiedPersonalCustomer.json"
import TRANSACTIONS_CREATEIMPERSONATEDUNVERIFIEDBUSINESSCUSTOMER from "./transactions/CreateImpersonatedUnverifiedBusinessCustomer.json"
import IDENTITY_AUTHENTICATEAS from "./identity/AuthenticateAs.json"
import IDENTITY_CHANGEMYIDENTITYEMAIL from "./identity/ChangeMyIdentityEmail.json"
import IDENTITY_CONFIRMMYIDENTITYEMAIL from "./identity/ConfirmMyIdentityEmail.json"
import ORGANIZATIONS_UPDATEMYORGANIZATION from "./organizations/UpdateMyOrganization.json"
import ORGANIZATIONS_SETMYORGANIZATIONCONTROLLER from "./organizations/SetMyOrganizationController.json"
import ORGANIZATIONS_RESETMYORGANIZATIONEMAILIDENTITY from "./organizations/ResetMyOrganizationEmailIdentity.json"
import ORGANIZATIONS_CREATEMYORGANIZATIONEMAILIDENTITY from "./organizations/CreateMyOrganizationEmailIdentity.json"
import ORGANIZATIONS_VERIFYMYORGANIZATIONEMAILIDENTITY from "./organizations/VerifyMyOrganizationEmailIdentity.json"
import TRANSACTIONS_UPLOADPERSONALCUSTOMERDOCUMENT from "./transactions/UploadPersonalCustomerDocument.json"
import TRANSACTIONS_UPLOADBUSINESSCUSTOMERDOCUMENTS from "./transactions/UploadBusinessCustomerDocuments.json"
import TRANSACTIONS_CERTIFYMYCUSTOMERBENEFICIALOWNERSHIP from "./transactions/CertifyMyCustomerBeneficialOwnership.json"
import TRANSACTIONS_CREATEMYCUSTOMERBENEFICIALOWNER from "./transactions/CreateMyCustomerBeneficialOwner.json"
import TRANSACTIONS_UPDATEMYCUSTOMERBENEFICIALOWNER from "./transactions/UpdateMyCustomerBeneficialOwner.json"
import TRANSACTIONS_UPLOADMYCUSTOMERBENEFICIALOWNERDOCUMENT from "./transactions/UploadMyCustomerBeneficialOwnerDocument.json"
import TRANSACTIONS_SUBMITMYSOURCEMICRODEPOSITS from "./transactions/SubmitMySourceMicroDeposits.json"
import ORGANIZATIONS_DISABLEORGANIZATION from "./organizations/DisableOrganization.json"
import ORGANIZATIONS_ENABLEORGANIZATION from "./organizations/EnableOrganization.json"

export default {
  BACKSTAGE_CREATEFILE,
  BACKSTAGE_UPDATEBATCH,
  BACKSTAGE_CLOSEPROJECT,
  BACKSTAGE_CREATEOPTION,
  BACKSTAGE_UPDATEPROJECT,
  BACKSTAGE_CREATEPROJECT,
  BACKSTAGE_CREATEPROPERTY,
  BACKSTAGE_ARCHIVEPROJECT,
  BACKSTAGE_PUBLISHPROJECT,
  BACKSTAGE_ENABLEMYUSER2FA,
  BACKSTAGE_UNPUBLISHPROJECT,
  BACKSTAGE_CREATEBATCHFILES,
  BACKSTAGE_UPDATEPARTNERPROJECT,
  BACKSTAGE_MAPINVESTMENTDOCUMENTS,
  BACKSTAGE_CREATEBATCHINVESTORFILES,
  NOTIFICATIONS_RESETTEMPLATE,
  NOTIFICATIONS_UPDATETEMPLATE,
  NOTIFICATIONS_TOGGLETEMPLATE,
  NOTIFICATIONS_SENDNOTIFICATION,
  NOTIFICATIONS_SENDCONTACTUSGUESTNOTIFICATION,
  NOTIFICATIONS_SENDCONTACTUSINVESTORNOTIFICATION,
  NOTIFICATIONS_SENDINVESTMENTPENDINGREFUNDNOTIFICATION,
  NOTIFICATIONS_SENDDISTRIBUTIONPENDINGAPPROVALNOTIFICATION,
  CAMPAIGNS_CLONECAMPAIGN,
  CAMPAIGNS_CREATECAMPAIGN,
  CAMPAIGNS_UPDATECAMPAIGN,
  CAMPAIGNS_PUBLISHCAMPAIGN,
  CAMPAIGNS_UNPUBLISHCAMPAIGN,
  CAMPAIGNS_UPDATECAMPAIGNTAGS,
  INVESTMENTS_CREATECOMMITMENT,
  INVESTMENTS_POSTPONECOMMITMENT,
  INVESTMENTS_CREATEACCOUNT,
  INVESTMENTS_UPDATEACCOUNT,
  INVESTMENTS_IMPORTACCOUNTS,
  INVESTMENTS_IMPORTINVESTMENTS,
  INVESTMENTS_UPDATEACCOUNTNOTE,
  INVESTMENTS_UPDATEMYINVESTMENT,
  INVESTMENTS_RESETACCOUNTIDENTITY,
  INVESTMENTS_CONNECTACCOUNTIDENTITY,
  INVESTMENTS_UPDATEINVESTMENTNOTE,
  INVESTMENTS_RESETINVESTMENTSUBSCRIPTION,
  INVESTMENTS_UPDATEINVESTMENTSOURCES,
  INVESTMENTS_MIGRATECOMMITMENT,
  INVESTMENTS_BACKUPINVESTMENT,
  INVESTMENTS_ACCEPTINVESTMENT,
  INVESTMENTS_REJECTINVESTMENT,
  INVESTMENTS_UPDATEMYINVESTMENTSOURCES,
  INVESTMENTS_CREATEACCOUNTINVESTMENT,
  INVESTMENTS_UPDATEMYINVESTMENTFUNDINGSTATUS,
  TRANSACTIONS_CONNECTSOURCE,
  TRANSACTIONS_FUNDINVESTMENT,
  TRANSACTIONS_REJECTTRANSACTION,
  TRANSACTIONS_CREATEBANKACCOUNT,
  TRANSACTIONS_APPROVETRANSACTION,
  TRANSACTIONS_CONNECTCUSTOMSOURCE,
  TRANSACTIONS_VERIFYMYCUSTOMSOURCE,
  TRANSACTIONS_RETRYERRORTRANSACTION,
  TRANSACTIONS_RETRYFAILEDTRANSACTION,
  TRANSACTIONS_TRANSFERCONTROLLERCUSTOMERS,
  TRANSACTIONS_UPDATEREJECTEDTRANSACTIONAMOUNT,
  TRANSACTIONS_CREATEUNVERIFIEDPERSONALCUSTOMER,
  TRANSACTIONS_CREATEUNVERIFIEDBUSINESSCUSTOMER,
  TRANSACTIONS_UPDATEMYSOURCEVERIFICATIONSTATUS,
  TRANSACTIONS_CREATERECEIVEONLYBUSINESSCUSTOMER,
  TRANSACTIONS_UPDATEMYCUSTOMERVERIFICATIONSTATUS,
  TRANSACTIONS_UPGRADEMYUNVERIFIEDPERSONALCUSTOMER,
  TRANSACTIONS_UPGRADEMYUNVERIFIEDBUSINESSCUSTOMER,
  TRANSACTIONS_CREATEIMPERSONATEDUNVERIFIEDPERSONALCUSTOMER,
  TRANSACTIONS_CREATEIMPERSONATEDUNVERIFIEDBUSINESSCUSTOMER,
  IDENTITY_AUTHENTICATEAS,
  IDENTITY_CHANGEMYIDENTITYEMAIL,
  IDENTITY_CONFIRMMYIDENTITYEMAIL,
  ORGANIZATIONS_UPDATEMYORGANIZATION,
  ORGANIZATIONS_SETMYORGANIZATIONCONTROLLER,
  ORGANIZATIONS_RESETMYORGANIZATIONEMAILIDENTITY,
  ORGANIZATIONS_CREATEMYORGANIZATIONEMAILIDENTITY,
  ORGANIZATIONS_VERIFYMYORGANIZATIONEMAILIDENTITY,
  TRANSACTIONS_UPLOADPERSONALCUSTOMERDOCUMENT,
  TRANSACTIONS_UPLOADBUSINESSCUSTOMERDOCUMENTS,
  TRANSACTIONS_CERTIFYMYCUSTOMERBENEFICIALOWNERSHIP,
  TRANSACTIONS_CREATEMYCUSTOMERBENEFICIALOWNER,
  TRANSACTIONS_UPDATEMYCUSTOMERBENEFICIALOWNER,
  TRANSACTIONS_UPLOADMYCUSTOMERBENEFICIALOWNERDOCUMENT,
  TRANSACTIONS_SUBMITMYSOURCEMICRODEPOSITS,
  ORGANIZATIONS_DISABLEORGANIZATION,
  ORGANIZATIONS_ENABLEORGANIZATION
}
